import { render, staticRenderFns } from "./newmediapromotion.vue?vue&type=template&id=62f73f0c&scoped=true&"
import script from "./newmediapromotion.vue?vue&type=script&lang=js&"
export * from "./newmediapromotion.vue?vue&type=script&lang=js&"
import style0 from "./newmediapromotion.vue?vue&type=style&index=0&id=62f73f0c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f73f0c",
  null
  
)

export default component.exports